<template>
	<button type="button" class="shrink-0 size-4 flex items-center justify-center rounded-full border border-[#F7001D] bg-[#FE445A] [&:hover_i]:inline-block!" @click.stop="emit('close')">
		<i class="fa-solid fa-xmark hidden! text-[#7F222D] text-[13px] font-black"/>
	</button>
</template>
<script setup lang="ts">
import {defineEmits} from 'vue'

const emit = defineEmits([
	'close',
])
</script>
